import type { Action } from 'state/actions';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import { addKey, patchKey, removeKey } from 'state/utils/collection';

import type {
  SecondaryMarketLoadingStatus,
  SecondaryMarketQuotesState,
  SecondaryMarketQuotesStateMap,
} from './secondaryMarketQuotes.model';
import { initialSecondaryMarketQuotesState } from './secondaryMarketQuotes.model';

export function secondaryMarketQuotesReducer(
  state: SecondaryMarketQuotesStateMap = initialSecondaryMarketQuotesState,
  action: Action,
): SecondaryMarketQuotesStateMap {
  const actionTypes: OrderActionType[] = ['CP_ORDER', 'LIMIT_ORDER', 'LIVE'];
  for (const actionType of actionTypes) {
    switch (action.type) {
      case 'SECONDARY_MARKET_QUOTES_WORKSPACE_ADD_TAB':
        return addKey(state, action.tabId, {
          key: action.key,
          initFormStatus: 'not_yet',
        } as SecondaryMarketQuotesState);

      case `SECONDARY_MARKET_${actionType}_INIT_FORM_FETCH_REQUESTED` as const:
      case `SECONDARY_MARKET_${actionType}_RELOAD_FORM_FETCH_REQUESTED` as const:
        if (action.workspace === 'secondaryMarketQuotes') {
          return patchKey(state, action.tabId, () => ({ initFormStatus: 'loading' as SecondaryMarketLoadingStatus }));
        }
        return state;
      case `SECONDARY_MARKET_${actionType}_INIT_FORM_FETCH_FAILED` as const:
      case `SECONDARY_MARKET_${actionType}_RELOAD_FORM_FETCH_FAILED` as const:
        if (action.workspace === 'secondaryMarketQuotes') {
          return patchKey(state, action.tabId, () => ({
            initFormStatus: 'failed' as SecondaryMarketLoadingStatus,
            errorKind: action.errorKind,
            errorMessage: action.message,
          }));
        }
        return state;
      case `SECONDARY_MARKET_${actionType}_INIT_FORM_FETCHED` as const:
      case `SECONDARY_MARKET_${actionType}_RELOAD_FORM_FETCHED` as const:
        if (action.workspace === 'secondaryMarketQuotes') {
          return patchKey(state, action.tabId, () => ({ initFormStatus: 'loaded' as SecondaryMarketLoadingStatus }));
        }
        return state;

      case 'SECONDARY_MARKET_QUOTES_WORKSPACE_REMOVE_TAB':
        return removeKey(state, action.tabId);
      default:
        continue;
    }
  }
  return state;
}
